// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs';
import { DATE_FORMAT } from './CreateVehiclePageV2.constants';

export const formatFileSize = (bytes) => {
	if (!bytes) return '';
	if (bytes < 1024) return `${bytes}b`;
	if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}kb`;
	return `${Math.round(bytes / (1024 * 1024))}mb`;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const transformVehicleToAPIFormat = (vehicle) => {
	const formatDate = (date) => (date ? dayjs(date).format(DATE_FORMAT) : null);

	if (vehicle.skip_document_upload) {
		const req_data = {
			vendor_id: vehicle.vendor_id,
			vehicle_number: vehicle.vehicle_number,
			vehicle_type_id: vehicle.vehicle_type_id,
			onboard_without_documents: true,
		};

		if (vehicle.gps_installed !== undefined && vehicle.gps_installed !== null) {
			req_data.gps_installed = vehicle.gps_installed;
			if (vehicle.gps_installed === true && vehicle.gps_provider_name) {
				req_data.gps_provider_name = vehicle.gps_provider_name;
			}
		}

		return req_data;
	}

	const req_data = {
		vendor_id: vehicle.vendor_id,
		vehicle_number: vehicle.vehicle_number,
		vehicle_type_id: vehicle.vehicle_type_id,
		ownership_type: vehicle.ownership_type || 'Own',
		document_info: {
			rc: {
				document_key: vehicle.rc_document_key,
				valid_till: formatDate(vehicle.rc_expiry_date),
			},
			insurance: {
				document_key: vehicle.insurance_document_key,
				valid_till: formatDate(vehicle.insurance_validity_date),
			},
		},
	};

	if (vehicle.puc_document_key) {
		req_data.document_info.puc = {
			document_key: vehicle.puc_document_key,
			valid_till: formatDate(vehicle.puc_expiry_date),
		};
	}

	if (vehicle.consent_letter_key) {
		req_data.document_info.consent_letter = {
			document_key: vehicle.consent_letter_key,
		};
	}

	if (vehicle.gps_installed !== undefined && vehicle.gps_installed !== null) {
		req_data.gps_installed = vehicle.gps_installed;
		if (vehicle.gps_installed === true && vehicle.gps_provider_name) {
			req_data.gps_provider_name = vehicle.gps_provider_name;
		}
	}

	return req_data;
};
